module.exports = __webpack_public_path__ + "static/media/movie.c070068f.jpg";